import React, { useEffect } from "react";
import "./Thank_you.css";

import Confirmation_Message from "./confirmation_message/Confirmation_Message";
import Dpu_alumni from "./dpu_alumni/Dpu_alumni";
import Hiring_Partners from "./hiring_partners/Hiring_Partners";

const Thank_you = () => {
  // useEffect(() => {
  //   const gtag_report_conversion = (url) => {
  //     const callback = function() {
  //       if (typeof url !== "undefined") {
  //         window.location = url;
  //       }
  //     };

  //     if (window.gtag) {
  //       window.gtag("event", "conversion", {
  //         send_to: "AW-17334514957/2uS9CJ2QzPAaEI3q3slA",
  //         value: 1.0,
  //         currency: "INR",
  //         event_callback: callback,
  //       });
  //     }
  //   };

  //   gtag_report_conversion();

  //   if (window.fbq) {
  //     window.fbq("track", "Lead", {
  //       value: 1,
  //       currency: "INR",
  //     });
  //   }

  //   if (window.gtag) {
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-16713947906/4SA0CIeb2_MbEIK26qE-",
  //       value: 1.0,
  //       currency: "INR",
  //     });
  //   }
  // }, []);

  useEffect(() => {
    // Google Ads Conversion
    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-16713947906/YQKACJisotwcEIK26qE-",
        value: 1.0,
        currency: "INR",
      });
    }

    // Facebook Lead Event
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead", {
        value: 1,
        currency: "INR",
      });
    }
  }, []);

  return (
    <>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          alt="facebook-pixel"
          src="https://www.facebook.com/tr?id=2360370587795642&ev=PageView&noscript=1"
        />
      </noscript>

      <section className="Thank_you_sec">
        <Confirmation_Message />
        {/* <Dpu_alumni /> */}
        <Hiring_Partners />
      </section>
    </>
  );
};

export default Thank_you;
